/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Spanish (es) string table
   English is the source of truth in the HTML; this file supplies the
   Spanish counterpart for each data-i18n key. Missing keys fall back to
   English automatically (see i18n.js). Hand this file to a translator or
   compliance reviewer; it is the single place Spanish copy lives.

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English. Neutral Spanish: informal "tú",
   never "vosotros" or formal "usted".
═════════════════════════════════════════════════════════════════════ */
window.TD_I18N = window.TD_I18N || {};
window.TD_I18N.es = Object.assign(window.TD_I18N.es || {}, {

  /* ── Nav (site-wide) ── */
  'nav.shop': 'Tienda',
  'nav.science': 'Ciencia',
  'nav.concerns': 'Necesidades',
  'nav.story': 'Nuestra historia',
  'nav.contact': 'Contacto',
  'nav.tryus': 'Pruébanos',
  'nav.faq': 'Preguntas frecuentes',
  'nav.drawerCta': 'Pruébanos · Discovery Kit',
  'nav.drawerFine': 'Cinco sérums vitamínicos · $70 · envío a todo el mundo',

  /* ── Announcement bar (site-wide) ── */
  'announce.0a': '<strong>Envío gratis</strong> en pedidos superiores a $150',
  'announce.0b': 'Enviado a todo el mundo desde Estocolmo',
  'announce.1a': '<strong>Crea una rutina y ahorra 10%</strong>',
  'announce.1b': 'Se aplica automáticamente en el pago',
  'announce.2a': 'Prueba los cinco sérums.',
  'announce.2b': '<strong>Envío gratis sobre $150</strong>',

  /* ── Homepage · hero ── */
  'home.hero.tagline': 'Cuidado de la piel sin concesiones · Est. 1998',
  'home.hero.h1': '<span class="l1">Sin agua.</span><br><span class="l2">Sin conservantes.</span><br><span class="l3">Sin aditivos.</span><br><span class="l4">Sin colorantes.</span><br><span class="l5">Sin aire.</span><br><span class="l6"><em class="hero-vitamins-em">Solo vitaminas activas.</em></span>',
  'home.hero.sub': 'Para una absorción dérmica real más allá de la superficie.<br>Cinco sérums vitamínicos. Cinco principios. Un sistema.',
  'home.hero.cta1': 'Explora los sérums',
  'home.hero.cta2': 'Cómo funciona',

  /* ── Homepage · coming-soon teaser (static only) ── */
  'home.cs.title': 'Campaña<br><em>Verano</em> 2026',
  'home.cs.shop': 'Sérums disponibles ahora',

  /* ── Homepage · press bar ── */
  'home.press.label': 'Aparecemos en',

  /* ── Homepage · collection ── */
  'home.coll.eyebrow': 'La colección',
  'home.coll.h2': 'Sérums vitamínicos formulados con precisión. <em>Desarrollados en Estocolmo.</em>',
  'home.coll.viewAll': 'Ver todos los productos',
  'home.coll.c.benefit': 'Protege, ilumina y reafirma con vitamina C pura.',
  'home.coll.a.benefit': 'Renovación impulsada por retinol mientras duermes.',
  'home.coll.o.benefit': 'Energiza las células y restaura la luminosidad visible.',
  'home.coll.m.benefit': 'Repara la barrera de hidratación. De forma profunda y duradera.',
  'home.coll.r.benefit': 'Reafirma y restaura. Reduce la apariencia de imperfecciones, marcas postacné y textura irregular con el tiempo.',
  'home.coll.kit.name': 'Discovery Kit',
  'home.coll.kit.benefit': 'Los cinco sérums en formato de bolsillo. Prueba el sistema completo antes de decidirte.',
  'home.coll.kit.badge': 'Nuevo',

  /* ── Homepage · science intro (shared) ── */
  'home.science.eyebrow': 'La ciencia',
  'home.science.h2': 'La entrega profunda es<br><em>la diferencia.</em>',
  'home.science.body': 'El sistema de entrega de Transderma transporta las vitaminas activas más allá de la epidermis hasta la dermis, donde ocurren la síntesis de colágeno y la renovación celular.',
  'home.science.readMore': 'Leer toda la ciencia →',

  /* ── Homepage · science skin diagram (static only) ── */
  'home.sci.serumLabel': 'Sérums<br>Transderma',
  'home.sci.l1.label': 'STRATUM CORNEUM',
  'home.sci.l1.desc': 'Capa más externa de la piel',
  'home.sci.l1.p': 'El stratum corneum es la barrera exterior de la piel: células muertas y compactadas que bloquean la mayor parte de lo que aplicamos. La fórmula sin agua de Transderma se absorbe a través de él en segundos tras la aplicación. Las vitaminas activas llegan intactas al tejido vivo de abajo, sin perder nada por evaporación.',
  'home.sci.l1.depth': '0 mm DE PROFUNDIDAD',
  'home.sci.l2.label': 'EPIDERMIS',
  'home.sci.l2.desc': 'Células vivas de la piel, melanocitos, terminaciones nerviosas',
  'home.sci.l2.p': 'La mayoría de los sérums se detienen aquí, depositados entre las células vivas de la epidermis, incapaces de avanzar. Transderma no contiene agua, por lo que cada gota mantiene su plena concentración vitamínica durante el recorrido. Nada se diluye por el camino; la fórmula sigue avanzando hacia la dermis.',
  'home.sci.l2.depth': '0,1 mm DE PROFUNDIDAD',
  'home.sci.l2.stop': 'La mayoría de los sérums se detienen aquí',
  'home.sci.barrier': 'BARRERA CUTÁNEA',
  'home.sci.l3.label': 'CAPA DÉRMICA',
  'home.sci.l3.desc': 'Colágeno, elastina, fibroblastos, vasos sanguíneos',
  'home.sci.l3.p': 'La dermis es donde realmente se produce el cambio duradero en la piel: el colágeno, la elastina y la renovación celular comienzan aquí. Transderma lleva vitaminas concentradas directamente a esta capa, donde los fibroblastos pueden ponerlas a trabajar. Esta es la capa que los sérums convencionales rara vez alcanzan, y la razón por la que nuestros resultados se ven a lo largo de las semanas.',
  'home.sci.l3.depth': '1–2 mm DE PROFUNDIDAD',
  'home.sci.l4.label': 'TEJIDO SUBCUTÁNEO',
  'home.sci.l4.desc': 'Tejido graso y soporte estructural profundo',
  'home.sci.l4.p': 'Bajo la dermis se encuentra la capa subcutánea, tejido graso que ancla la piel y mantiene su forma. A esta profundidad, las vitaminas de Transderma ya han sido absorbidas por la dermis superior. El tejido aquí es la base estructural para la renovación que ocurre en cada capa construida sobre él.',
  'home.sci.l4.depth': '4–10 mm DE PROFUNDIDAD',
  'home.sci.reach': 'TRANSDERMA LLEGA HASTA AQUÍ',

  /* ── Homepage · purity / five nos (static + theme strip) ── */
  'home.purity.eyebrow': 'La diferencia',
  'home.purity.h2': 'No es lo que<br><em>esperas.</em>',
  'home.purity.water.title': 'Sin agua',
  'home.purity.water.body': 'Fórmula sin agua. Mayor concentración, entrega más profunda.',
  'home.purity.preserv.title': 'Sin conservantes',
  'home.purity.preserv.body': 'Sin agua, los microbios no pueden crecer. No hacen falta.',
  'home.purity.fillers.title': 'Sin aditivos',
  'home.purity.fillers.body': 'Cada ingrediente es funcional. Sin emulsionantes, espesantes ni rellenos de volumen.',
  'home.purity.dyes.title': 'Sin colorantes',
  'home.purity.dyes.body': 'El tono que ves proviene de los activos en crudo, no de un color añadido.',
  'home.purity.air.title': 'Sin aire',
  'home.purity.air.body': 'Sellado en una bomba airless. Potencia completa, desde la primera gota hasta la última.',

  /* ── Homepage · pure formulation strip header (liquid only) ── */
  'home.strip.eyebrow': 'Formulación pura',
  'home.strip.h3': 'Solo vitaminas activas.<br><em>Nada más.</em>',

  /* ── Homepage · trust commitments (liquid only) ── */
  'home.trust.cruelty': '<strong>Nunca testado en animales.</strong> Libre de crueldad desde el primer día.',
  'home.trust.vegan': '<strong>Formulaciones veganas.</strong> Sin ingredientes de origen animal.',
  'home.trust.made': '<strong>Fabricado en Estocolmo.</strong> Aprobado en laboratorio por Läkemedelsverket.',
  'home.trust.eu': '<strong>Registrado como cosmético en la UE.</strong> Vendido en clínicas de 14 países.',

  /* ── Homepage · airless section (liquid only) ── */
  'home.airless.eyebrow': 'Diseño airless',
  'home.airless.h2': 'Sellado desde el primer bombeo<br><em>hasta el último.</em>',
  'home.airless.body': 'El aire es lo que envejece un sérum. La bomba airless cierra esa puerta. La última gota tiene la misma potencia que la primera.',

  /* ── Homepage · sample / discovery kit ── */
  'home.sample.eyebrow': '¿No sabes por dónde empezar?',
  'home.sample.h2': 'Prueba los cinco<br><em>por $70.</em>',
  'home.sample.body': 'El Transderma Discovery Kit contiene versiones en formato de bolsillo de los cinco sérums y una guía impresa para construir tu rutina. Es como la mayoría de nuestros clientes a largo plazo nos descubrieron por primera vez.',
  'home.sample.bodyTheme': 'El Transderma Discovery Kit contiene versiones en formato de bolsillo de los cinco sérums. Es como la mayoría de nuestros clientes a largo plazo nos descubrieron por primera vez.',
  'home.sample.cta': 'Conseguir el Discovery Kit',
  'home.sample.fine': '$5 de envío · Incluye guía impresa de necesidades de la piel',
  'home.sample.fineTheme': '$5 de envío a todo el mundo · Enviado desde Estocolmo',
  'home.sample.f1.h': 'Los cinco sérums',
  'home.sample.f1.p': 'En formato de bolsillo, perfectos para quienes están en movimiento. Aproximadamente 7 días de uso constante.',
  'home.sample.f1.pTheme': 'Frascos de bolsillo de 3 ml, perfectos para quienes están en movimiento. Aproximadamente 7 días de uso constante por frasco.',
  'home.sample.f2.h': 'Guía de necesidades de la piel',
  'home.sample.f2.p': 'Una guía impresa para ayudarte a encontrar qué sérums funcionan mejor para tus necesidades específicas.',
  'home.sample.f2.hTheme': 'Los cinco, lado a lado',
  'home.sample.f2.pTheme': 'Prueba cada fórmula en tu rutina durante la misma semana y encuentra las combinaciones que funcionan para tu piel.',
  'home.sample.f3.h': 'Sin compromiso',
  'home.sample.f3.p': 'Descubre si Transderma es para ti. La mayoría lo sabe en cuestión de días.',

  /* ── Homepage · skin concerns ── */
  'home.conc.eyebrow': 'Encuentra tu fórmula',
  'home.conc.h2': 'Compra por<br><em>necesidad de la piel.</em>',
  'home.conc.firm.t': 'Firmeza',
  'home.conc.firm.d': 'Pérdida de elasticidad y definición en la línea de la mandíbula y las mejillas.',
  'home.conc.bright.t': 'Luminosidad',
  'home.conc.bright.d': 'Tono desigual, opacidad y decoloración por exposición ambiental, cicatrices o marcas postacné.',
  'home.conc.hydrate.t': 'Hidratación',
  'home.conc.hydrate.d': 'Piel seca, descamación y una barrera de hidratación debilitada que no retiene.',
  'home.conc.lines.t': 'Líneas finas',
  'home.conc.lines.d': 'Líneas superficiales y arrugas de expresión más profundas que se desarrollan con el tiempo.',
  'home.conc.viewAll': 'Ver todas las necesidades →',

  /* ── Homepage · heritage / founder ── */
  'home.her.caption': 'Dr. Klaus Alvin Ronlán, Ph.D.<br><span>1942 — 2018 · Docente</span>',
  'home.her.eyebrow': 'El fundador',
  'home.her.h2': 'Treinta años.<br><em>La misma fórmula.</em>',
  'home.her.body': 'Transderma nació en un laboratorio de Estocolmo, fundada por el Dr. Klaus Alvin Ronlán tras veinticinco años de investigación en la Universidad de Lund. Cinco sérums, lanzados en 1998. Mantenidos sin cambios desde el fallecimiento del Dr. Ronlán en 2018. Sigue siendo de propiedad independiente. Sigue fabricándose en Suecia.',
  'home.her.bodyTheme': 'Transderma nació en un laboratorio de Estocolmo, fundada por el Dr. Klaus Alvin Ronlán tras veinticinco años de investigación. Sigue siendo de propiedad independiente. Sigue fabricándose en Suecia.',
  'home.her.cta': 'Lee la historia del Dr. Ronlán →',

  /* ── Awards · Recognition (site-wide) ── */
  'awards.label': 'Galardonado',
  'awards.serumC': 'Nordic Natural Beauty Awards · Ganador 2020',
  'awards.serumA': 'Global Makeup Awards · Plata, Escandinavia 2022',
  'awards.serumO': 'Swedish Beauty &amp; Cosmetics Awards · Ganador 2016',
  'awards.serumM': 'Nordic Natural Beauty Awards · Ganador 2020',
  'awards.serumR': 'ELLE Sweden Beauty Awards · Ganador 2013',
  'awards.fullLine': 'Galardonado por · ELLE Sweden Beauty Awards · Nordic Natural Beauty Awards · Swedish Beauty &amp; Cosmetics Awards · Global Makeup Awards · LUXlife Magazine',
  'awards.aboutLine': 'Galardonado · ELLE Sweden 2013 · Swedish Beauty &amp; Cosmetics 2016 · Nordic Natural Beauty 2020 · Global Makeup 2022 · LUXlife 2021',

  /* ── Press pull-quotes (real editorial reviews) ── */
  'quote.home.text': '«Cuidado de la piel altamente efectivo, en su máxima expresión.»',
  'quote.home.cite': 'Melissa Davis · The Beauty Librarian',
  'quote.serumR.text': '«Como magia para la piel. Mi problema de pigmentación en el labio superior desapareció.»',
  'quote.serumR.cite': 'Teresa Grundin · Styleby, 2014',
  'quote.serumC.text': '«La ciencia detrás de este producto y la simplicidad de la fórmula son impresionantes.»',
  'quote.serumC.cite': 'Truth In Aging',
  'quote.serumA.text': '«Cuidado de la piel al máximo. Transderma A y C.»',
  'quote.serumA.cite': 'Teresa Grundin · Elle.se, 2014',

  /* ── Footer (site-wide) ── */
  'footer.tagline': 'Est. 1998 · Estocolmo',
  'footer.location': 'Estocolmo, Suecia',
  'footer.col.serums': 'Sérums',
  'footer.col.shop': 'Tienda',
  'footer.col.learn': 'Aprende',
  'footer.col.support': 'Atención al cliente',
  'footer.serums.kit': 'Discovery Kit',
  'footer.serums.gift': 'Tarjetas de regalo',
  'footer.shop.all': 'Todos los sérums',
  'footer.learn.research': 'Investigación del Dr. Ronlán',
  'footer.learn.science': 'La ciencia',
  'footer.learn.concerns': 'Necesidades de la piel',
  'footer.learn.story': 'Nuestra historia',
  'footer.learn.about': 'Sobre el Dr. Ronlán',
  'footer.support.faq': 'Preguntas frecuentes',
  'footer.support.shipping': 'Envíos y devoluciones',
  'footer.support.stockists': 'Puntos de venta',
  'footer.support.contact': 'Contacto',
  'footer.support.privacy': 'Privacidad',
  'footer.support.terms': 'Términos',
  'footer.copy': '© 2026 Transderma®. Todos los derechos reservados. Estocolmo, Suecia.<svg class="ft-flag" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg" aria-label="España"><rect width="60" height="40" fill="#C60B1E"/><rect y="10" width="60" height="20" fill="#FFC400"/></svg>',
  'footer.links.privacy': 'Privacidad',
  'footer.links.terms': 'Términos',

  /* ── Certifications strip (homepage) ── */
  'certifications.label': 'Certificaciones',
  'certifications.ewg': 'EWG Verificado',
  'certifications.certclean': 'CertClean Certificado'

});
